export const SAVE_SETTING_UPSELL_BUNDLE_CAMPAIGN = 'SAVE_SETTING_UPSELL_BUNDLE_CAMPAIGN';
export const SAVE_SETTING_UPSELL_BUNDLE_CAMPAIGN_RESULT = 'SAVE_SETTING_UPSELL_BUNDLE_CAMPAIGN_RESULT';

export const GET_LIST_UPSELL_BUNDLE = 'GET_LIST_UPSELL_BUNDLE';
export const GET_LIST_UPSELL_BUNDLE_RESULT = 'GET_LIST_UPSELL_BUNDLE_RESULT';

export const GET_DETAIL_CAMPAIGN_UPSELL_BUNDLE = 'GET_DETAIL_CAMPAIGN_UPSELL_BUNDLE';
export const GET_DETAIL_CAMPAIGN_UPSELL_BUNDLE_RESULT = 'GET_DETAIL_CAMPAIGN_UPSELL_BUNDLE_RESULT';

export const CHANGE_TARGET_PRODUCT_UPSELL_BUNDLE = 'CHANGE_TARGET_PRODUCT_UPSELL_BUNDLE';
export const CHANGE_TARGET_PRODUCT_UPSELL_BUNDLE_RESULT = 'CHANGE_TARGET_PRODUCT_UPSELL_BUNDLE_RESULT';
export const CHANGE_UPSELL_BUNDLE_SETTING_FIELD = 'CHANGE_UPSELL_BUNDLE_SETTING_FIELD';
export const CHANGE_UPSELL_BUNDLE_PRODUCT_DETAIL_FIELD = 'CHANGE_UPSELL_BUNDLE_PRODUCT_DETAIL_FIELD';
export const CHANGE_UPSELL_BUNDLE_FIELD = 'CHANGE_UPSELL_BUNDLE_FIELD';
export const REMOVE_TARGET_PRODUCT_UPSELL_BUNDLE = 'REMOVE_TARGET_PRODUCT_UPSELL_BUNDLE';

export const CHANGE_STATUS_UPSELL_BUNDLE = 'CHANGE_STATUS_UPSELL_BUNDLE';
export const CHANGE_STATUS_UPSELL_BUNDLE_RESULT = 'CHANGE_STATUS_UPSELL_BUNDLE_RESULT';
export const DELETE_CAMPAIGN_UPSELL_BUNDLE = 'DELETE_CAMPAIGN_UPSELL_BUNDLE';
export const DELETE_CAMPAIGN_UPSELL_BUNDLE_RESULT = 'DELETE_CAMPAIGN_UPSELL_BUNDLE_RESULT';
